import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    InitiateImport2Import as InitiateImport2ImportMutation,
    InitiateImport2ImportVariables as InitiateImport2ImportMutationVariables,
    ImportInitiateInput,
} from 'nutshell-graphql-types';

import INITIATE_IMPORT from '../mutations/initiate-import2-import.graphql';

export function useInitiateImport(): {
    importInitiate: (arg1: ImportInitiateInput) => Promise<any>;
    isLoading: boolean;
    initiateError: string | null | undefined;
} {
    const [initiateImport, {loading: isLoading, error}] = useMutation<
        InitiateImport2ImportMutation,
        InitiateImport2ImportMutationVariables
    >(INITIATE_IMPORT);

    return {
        importInitiate: (input: ImportInitiateInput) =>
            initiateImport({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        initiateError: safelyGetGraphQLErrorMessage(error),
    };
}
